const arrowRight = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polyline stroke-width="1.5" points="6 12 10 7.96 6.08 4"/></svg>',
};

export { arrowRight as default };
